import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  timer: {
    fontSize: theme.spacing(3),
    padding: theme.spacing(1, 2),
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.bannerTimer.background,
  },

  loading: {
    width: theme.spacing(36.25),
  },

  fullDateContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },

  fullDate: {
    fontSize: theme.spacing(2),
    padding: theme.spacing(1, 1),
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.bannerTimer.background,
  },
}));
